import {
  PlusIcon_default
} from "./chunk-GFJI42GZ.mjs";
export {
  PlusIcon_default as default
};
